import { createFileRoute } from "@tanstack/react-router";
import { AboutPage } from "@/components/blocks/about/AboutPage";
import {
	buildPageBreadcrumb,
	buildPageSeo,
	loadPageLocale,
} from "@/lib/page-seo";

export const Route = createFileRoute("/{-$locale}/a-propos")({
	component: AboutPage,
	loader: loadPageLocale,
	head: ({ loaderData }) =>
		loaderData
			? buildPageSeo("about", loaderData.locale, {
					structuredData: [buildPageBreadcrumb(loaderData.locale, ["about"])],
				})
			: {},
});
